import { useState, useEffect } from 'react';

import PublicQuery from 'library/util/public-query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';

const useWithProgramSearchData = ({
  occupation,
  filters,
  query = PublicQuery,
}) => {
  const [programResults, setProgramResults] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPrograms = async () => {
      setLoading(true);
      try {
        const params = { ...filters };
        params['query_string'] = occupation;

        // if the user selects multiple radii, sort and submit the highest selected value
        if (params['miles_to_user'] && params['miles_to_user'].length) {
          params['miles_to_user'] = params['miles_to_user'].sort()[
            params['miles_to_user'].length - 1
          ];
        } else {
          delete params['miles_to_user'];
        }

        const result = await query(`
          {
            search_programs (${jsonToInputParams(params)}) {
              pagination
              {
                limit
                offset
                total
              }
              results {
                name
                url
                program_format {
                  name
                  ui_name
                }
                etpl
                provider {
                  name
                }
                degree {
                  id
                  name
                  ui_name
                }
              }
            }
          }
        `);

        let success = Object.keys(resolve(result, 'data/search_programs', {}))
          .length;
        if (success) {
          setProgramResults(resolve(result, 'data/search_programs', {}));
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.error(e);
      }
    };

    getPrograms();
  }, [filters, occupation]);

  return {
    loading,
    programResults,
  };
};

export default useWithProgramSearchData;
